import React from 'react';
import keycloak from '../keyCloak';
import { TbLogout } from "react-icons/tb";
import FirstNameDisplay from './FirstNameDisplay';
import './LogOut.css';

const Logout = () => {
  const handleLogout = () => {
    keycloak.logout({
      redirectUri: window.location.origin,
    });
  };

  return (
    <>
      <FirstNameDisplay />
      <div className="logout-button" onClick={handleLogout}>
        <p>Uitloggen</p>
        <TbLogout size={20} />
      </div>
    </>
  );
};

export default Logout;
